@use '@lib/assets/styles/main.scss' as *;

.counter {
  display: block;
  color: $gray500;
  padding-bottom: 8px;
  text-transform: lowercase;
}
